import React, { useEffect, useRef } from 'react';
import { Box, Toolbar } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import { unsavedDrafts } from './utils/localDrafts';
import Navbar from './components/Navbar';

export default function App() {
  const { pathname } = useLocation();
  const main = useRef(null);
  useEffect(() => {
    const heading = main.current?.querySelector('h1');
    const section = main.current?.querySelector('form h2')?.textContent;
    document.title = `${[heading?.textContent || 'Chem Lab Skills', section].filter(Boolean).join(' — ')} — Chem Lab Skills`;
    main.current?.focus({ preventScroll: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    const warn = event => {
      if (![...unsavedDrafts.values()].some(records => records.size)) return;
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, []);
  return <>
    <a className="skip-link" href="#main-content">Skip to main content</a>
    <Navbar />
    <Toolbar />
    <Box component="main" id="main-content" tabIndex={-1} ref={main} sx={{ pb: 5 }}>
      <Outlet />
    </Box>
  </>;
}
